import React, { useEffect } from 'react';
import { CheckPicker } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAll as getAssocLinkOptions,
  getFetched
} from '../../redux/Guest/selectors/association-link-options';
import { fetchAssociationLinkOptions } from '../../redux/Guest/sagas/routines';

export default function AssociationLinkCheckPicker(props) {
  const dispatch = useDispatch();
  const options = useSelector(getAssocLinkOptions);
  const isFetched = useSelector(getFetched);

  useEffect(
    () => {
      if (!isFetched) dispatch(fetchAssociationLinkOptions());
    },
    [isFetched]
  );

  return <CheckPicker {...props} data={options} />;
}
